'use client'

import React from 'react'
import { ISection, ITheme, Language } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'
import Image from 'next/image'
import '../../sass/menu/ModernImageBlock.scss'

interface ModernImageBlockProps {
  section: ISection
  theme: ITheme
  language: Language
  fontStyle: {
    fontFamily: NextFont
    fontSize: string
  }
}

const ModernImageBlock: React.FC<ModernImageBlockProps> = ({ section, theme, language }) => {
  const imageUrl = section.imageblock?.url
  const fullWidth = section.imageblock?.fullWidth ?? false
  const caption = section.imageblock?.[`caption_${language}` as keyof typeof section.imageblock] as string | undefined

  if (!imageUrl) return null

  const hasCaption = caption && caption.trim() !== ''

  return (
    <div className={`modern-section modern-image-section ${fullWidth ? 'full-width' : ''} ${hasCaption ? 'with-caption' : ''}`}>
      <div className='modern-items-grid'>
        <div className='modern-item-wrapper modern-image-wrapper' style={{ '--animation-index': 0 } as React.CSSProperties}>
          <div className='modern-image-block-card'>
            <div className='modern-image-block-content'>
              <Image
                src={imageUrl}
                alt={caption || 'Menu image'}
                fill
                style={{ objectFit: fullWidth ? 'cover' : 'contain' }}
                sizes='(max-width: 768px) 100vw, 800px'
              />
            </div>
            {hasCaption && (
              <div className='modern-image-block-caption'>
                <p>{caption}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernImageBlock
